import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter, Route, Switch } from 'react-router-dom'
import { hotjar } from 'react-hotjar'

import {
  setBrowserHistory,
  isAmbienteProd,
  initGoogleAnalytics,
  notifyGoogleAnalyticsTracking
} from '../util/applicationContext'
import ForbiddenAccess from '../components/ForbiddenAccess'
import HttpErrorView from '../components/HttpErrorView'
import AuthenticatedRoute from './AuthenticatedRoute'
import SSO from '../components/SSO'
import Login from '../components/Login'
import Logout from '../components/Logout'
import PainelAlertas from '../components/alertas/PainelAlertas'
import PainelPrincipal from '../components/itens/PainelPrincipal'
import NotFoundPage from '../components/NotFoundPage'
import UpdateBrowser from '../components/UpdateBrowser'
import LoginE2E from '../components/LoginE2E'

class AppRoutes extends Component {
  constructor(props) {
    super(props)
    const { history } = this.props
    setBrowserHistory(history)
    this.initHotjar()
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const {
      unidadesUsuario: { codigoUsuario }
    } = this.props
    const {
      unidadesUsuario: { codigoUsuario: prevCodigoUsuario }
    } = prevProps
    this.updateHotjarLocationListeners()

    if (codigoUsuario !== prevCodigoUsuario) {
      initGoogleAnalytics(codigoUsuario)
    }

    this.notifyGoogleAnalyticsTracking(prevProps)
  }

  initHotjar() {
    if (isAmbienteProd()) {
      hotjar.initialize(947173, 6)
    }
  }

  notifyGoogleAnalyticsTracking(prevProps) {
    const {
      location: { pathname }
    } = this.props
    const {
      location: { pathname: prevPathname }
    } = prevProps

    if (pathname !== prevPathname) {
      notifyGoogleAnalyticsTracking(pathname)
    }
  }

  updateHotjarLocationListeners() {
    if (window.hj && isAmbienteProd()) {
      const { history } = this.props
      history.listen((location) => window.hj('stateChange', location.pathname))
    }
  }

  setTitle() {
    document.title = 'e-TCU - Pessoal'
  }

  render() {
    this.setTitle()
    return (
      <Switch>
        {/* Defina as rotas por ordem de especificidade, das mais específicas para as mais genéricas... */}
        <Route path='/sso/username/:username/token/:token' component={SSO} />
        <Route path='/sso' component={SSO} />
        <Route path='/login' component={Login} />
        <Route path='/login-e2e' component={LoginE2E} />
        <Route path='/logout' component={Logout} />
        <Route path='/updatebrowser' component={UpdateBrowser} />
        <Route path='/forbidden' component={ForbiddenAccess} />
        <Route path='/httperror' component={HttpErrorView} />
        <AuthenticatedRoute path='/alertas' component={PainelAlertas} />
        <AuthenticatedRoute exact path='/' component={PainelPrincipal} />
        <Route component={NotFoundPage} />
      </Switch>
    )
  }
}

const mapStateToProps = ({ unidadesUsuario }) => ({ unidadesUsuario })

const reduxEnhanced = connect(mapStateToProps)(AppRoutes)

export default withRouter(reduxEnhanced)
